<template>
  <iframe
    style="height: 100%; width: 100%; border: none"
    src="http://wicrecloud.cn/help/projchangshou/help.html"
  ></iframe>
</template>

<script>
export default {};
</script>

<style>
</style>